'use client';

import Header from '@/components/layout/header';
import { Alert } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { XCircle } from '@phosphor-icons/react';
import { captureException } from '@sentry/nextjs';
import type NextError from 'next/error';
import { useState } from 'react';
import { useEffect } from 'react';
export default function GlobalError({
  error,
  reset
}: {
  error: NextError & {
    message?: string;
    digest?: string;
  };
  reset: () => void;
}) {
  const [sentryErrorId, setSentryErrorId] = useState<string | undefined>(undefined);
  useEffect(() => {
    setSentryErrorId(captureException(error));
  }, [error]);
  const serverError = 'An error occured in the Server Components render';
  return <html data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        <div className="mx-auto flex max-w-3xl flex-col justify-center gap-6 px-6 py-24 relative">
          <Header data-sentry-element="Header" data-sentry-source-file="global-error.tsx" />

          <Alert variant="destructive" data-sentry-element="Alert" data-sentry-source-file="global-error.tsx">
            <XCircle data-sentry-element="XCircle" data-sentry-source-file="global-error.tsx" />
            <Alert.Title data-sentry-element="unknown" data-sentry-source-file="global-error.tsx">Uh oh, something went wrong!</Alert.Title>
            <Alert.Description data-sentry-element="unknown" data-sentry-source-file="global-error.tsx">
              <div className="flex flex-col">
                <div className="flex flex-col">
                  <p>Try again later, or send us your feedback if this problem continues to occur.</p>
                  {sentryErrorId && <p>Id: {sentryErrorId}</p>}
                  {error.digest && <p>Details: {error.digest}</p>}
                  {error.message && !error.message.includes(serverError) && <p>{error.message}</p>}
                </div>
              </div>
              <Button size="sm" onClick={() => reset()} className="bg-red-600 hover:bg-red-700 text-white" data-sentry-element="Button" data-sentry-source-file="global-error.tsx">
                Try again
              </Button>
            </Alert.Description>
          </Alert>
        </div>
      </body>
    </html>;
}